<script setup lang="ts">
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';
import { useAuthStore } from '@/stores/auth.store';
import { getCurrentLocale } from '@/i18n';
import ToastContainer from '@/components/ui/ToastContainer.vue';

const auth = useAuthStore();

onMounted(async () => {
  // Set <html lang>
  if (typeof document !== 'undefined') {
    document.documentElement.lang = getCurrentLocale();
  }
  // Best-effort silent refresh on first paint
  if (!auth.isAuthenticated && !auth.bootstrapping) {
    await auth.bootstrap();
  }
});
</script>

<template>
  <RouterView />
  <ToastContainer />
</template>
